import log from 'util/log';

const value = (valueOrFunction) => (typeof valueOrFunction === "function") ? valueOrFunction() : valueOrFunction;

const saveState = (key, getState = () => ({})) => {
  window.stateSaver = {
    ...window.stateSaver,
    [key]: getState,
  };

  window.snapSaveState = () => {
    const stateSaver = window.stateSaver || { };

    return Object.keys(stateSaver).reduce((state, key) => ({
      ...state,
      [key]: stateSaver[key]()
    }), { });
  };
};

export const rehydrateState = (key, initialState, getState, ifNotSaved = () => {}) => {
  let state;
  log.info("RS: Does the key exist?");
  if (window[key]) {
    log.info("RS: Yes, it does, let's store its value and delete it");
    state = window[key];
    delete window[key];
  } else {
    log.info("RS: No, it doesn't, so get the initial state");
    state = value(initialState);
    saveState(key, getState);
    ifNotSaved();
  }
  log.info("RS: returning state", state);
  return state;
};



// WEBPACK FOOTER //
// ./src/service/saved-state.js